(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    const STORAGE_KEY = 'shopify_wishlist';

    function getWishlist() {
      try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      } catch {
        return [];
      }
    }

    function saveWishlist(list) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    }

    function syncButtons() {
      const wishlist = getWishlist();
      document.querySelectorAll('.wishlist-btn').forEach(function (btn) {
        const id = btn.dataset.productId;
        btn.classList.toggle('is-active', wishlist.includes(id));
        btn.setAttribute(
          'aria-label',
          wishlist.includes(id) ? 'Quitar de favoritos' : 'Agregar a favoritos'
        );
      });
    }

window.toggleWishlist = function (btn) {
      const id = btn.dataset.productId;
      const wishlist = getWishlist();
      const idx = wishlist.indexOf(id);

      if (idx === -1) {
        wishlist.push(id);
      } else {
        wishlist.splice(idx, 1);
      }

      saveWishlist(wishlist);
      syncButtons();

      // Actualizar badge de la barra de navegación inmediatamente
      if (typeof updateWishlistNavCount === 'function') {
        updateWishlistNavCount();
      }
    };

    document.addEventListener('DOMContentLoaded', syncButtons);
  })();
  } catch(e) { console.error(e); }
})();

})();
